import { createFileRoute, redirect, useParams } from "@tanstack/react-router";

import { CliPerformance } from "@/components/cli-performance";
import { env } from "@/env/client";

export const Route = createFileRoute("/_app/$tenantId/cli-performance")({
	beforeLoad: ({ params }) => {
		if (env.VITE_CLI_PERFORMANCE_REPORT_ENABLED !== "true") {
			throw redirect({
				to: "/$tenantId",
				params: { tenantId: params.tenantId },
			});
		}
	},
	component: CliPerformanceRouteComponent,
});

function CliPerformanceRouteComponent() {
	const { tenantId } = useParams({
		from: "/_app/$tenantId/cli-performance",
	});

	return <CliPerformance organizationId={tenantId} />;
}
